import { Navigate, useLocation } from 'react-router-dom';

// ── 用户鉴权 Keys ────────────────────────────────────────
const AUTO_LOGIN_KEY = 'yh_auto_login_expiry';
const SESSION_LOGIN_KEY = 'yh_session_login';

// ── 管理员鉴权 Keys ──────────────────────────────────────
const ADMIN_AUTO_LOGIN_KEY = 'yh_admin_auto_login_expiry';
const ADMIN_SESSION_LOGIN_KEY = 'yh_admin_session_login';

export { SESSION_LOGIN_KEY, ADMIN_SESSION_LOGIN_KEY, ADMIN_AUTO_LOGIN_KEY };

export function isLoggedIn(): boolean {
  const expiry = localStorage.getItem(AUTO_LOGIN_KEY);
  if (expiry && Date.now() < parseInt(expiry, 10)) return true;
  return sessionStorage.getItem(SESSION_LOGIN_KEY) === '1';
}

export function isAdminLoggedIn(): boolean {
  const expiry = localStorage.getItem(ADMIN_AUTO_LOGIN_KEY);
  if (expiry && Date.now() < parseInt(expiry, 10)) return true;
  return sessionStorage.getItem(ADMIN_SESSION_LOGIN_KEY) === '1';
}

export { AUTO_LOGIN_KEY };

interface Props {
  children: React.ReactNode;
}

/** 普通用户路由守卫 → 未登录跳 /login */
export default function RequireAuth({ children }: Props) {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

/** 管理员路由守卫 → 未登录跳 /admin/login */
export function RequireAdminAuth({ children }: Props) {
  const location = useLocation();
  if (!isAdminLoggedIn()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
